import RavnurPlayer from '@Ravnur-Inc/player';

import { VideoSource } from '@/types/VideoSource';

export default function prepareSources(sources: VideoSource[], preferHLS = true): VideoSource[] {
  return sources.map((src) => _prepareSingleSource(src, preferHLS));
}

export function prepareSource(sources: VideoSource, preferHLS = true): VideoSource {
  return _prepareSingleSource(sources, preferHLS);
}

function _prepareSingleSource(source: VideoSource, preferHLS = true): VideoSource {
  const src = (source as any).sources;
  const hlsType = 'application/x-mpegURL';

  if (/^audio/.test(source.type)) {
    source.poster = source.poster || '/default-audio-thumb.jpg';
    source.type = 'audio/mp4';
  } else {
    source.type = 'video/mp4';
  }

  if (typeof src === 'string') {
    source.type = hlsType;

    return { ...source, src };
  }

  if (src instanceof Array) {
    const canPlayHLS = preferHLS && RavnurPlayer.canPlayHLS;
    const type = canPlayHLS ? hlsType : source.type;
    const filtered = src.filter((s) => s.type === type);

    if (canPlayHLS && filtered.length) {
      const [s] = filtered;
      source.type = type;
      source.src = s.src;

      return source;
    }

    (source as any).src = filtered.length ? filtered : src;
  }

  return { ...source, src };
}
